import enCA from './en_CA.json';
import frCA from './fr_CA.json';

const locales = {
    en_CA: enCA,
    fr_CA: frCA,
};

export default locales;
